module.exports = __webpack_public_path__ + "static/media/500.5e6bf3ad.svg";